import * as React from "react";

import SelectField from "../../../components/SelectField";
import Button from "../../../components/Button";
import {OptionWorkflowStatusMultiUpdateParamActionType} from "../../../services/Client";

interface IWSMUActionSelectionProps {
    value: OptionWorkflowStatusMultiUpdateParamActionType | undefined;
    t: reactI18Next.TranslationFunction;

    // actions
    onChange: (value: OptionWorkflowStatusMultiUpdateParamActionType | undefined) => void;
    nextAction: () => void;
}

export const renderActionTypeLabel = (value: OptionWorkflowStatusMultiUpdateParamActionType | undefined, t: reactI18Next.TranslationFunction) => {
    switch (value) {
        case OptionWorkflowStatusMultiUpdateParamActionType.RESET:
            return t("PSL_WF_S_MULTI:RESET_ACTION");
        case OptionWorkflowStatusMultiUpdateParamActionType.MOVE_FORWARD:
            return t("PSL_WF_S_MULTI:MOVE_FORWARD_ACTION");
        default:
            return '';
    }
};

export const WSMUActionSelection: React.StatelessComponent<IWSMUActionSelectionProps> = (props: IWSMUActionSelectionProps) => {

    return (
        <>
            <SelectField
                placeholder={props.t("PSL_WF_S_MULTI:SELECT_ACTION")}
                value={props.value}
                dataSource={[OptionWorkflowStatusMultiUpdateParamActionType.RESET,
                OptionWorkflowStatusMultiUpdateParamActionType.MOVE_FORWARD]}
                rendererKey={(value: OptionWorkflowStatusMultiUpdateParamActionType) => renderActionTypeLabel(value, props.t)}
                onChange={props.onChange}
            />
            <div style={{marginTop: '20px', textAlign: 'right'}}>
                <Button
                    icon={'arrow right'}
                    disabled={props.value === undefined}
                    onClick={props.nextAction}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowStatusMultiUpdate/WSMUActionSelection.tsx